import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { BukTicketPublicationMethod } from '../../models/buk-ticket.model';

@Component({
  selector: 'app-buk-ticket-publication-method-selector',
  templateUrl: './buk-ticket-publication-method-selector.component.html',
  styleUrls: ['./buk-ticket-publication-method-selector.component.scss'],
})
export class BukTicketPublicationMethodSelectorComponent implements OnInit {
  @Output() methodChange = new EventEmitter<BukTicketPublicationMethod>();

  public publicationMethod: BukTicketPublicationMethod = 'email';

  ngOnInit(): void {
    this.methodChange.emit(this.publicationMethod);
  }
}
